import React from "react";

function WhatMakeUs(){
    return(
        <>
        {/* SECOND SCROLL */}
            <div className="what-Make-Us-section" id="about-us">
                <div className="container">
                    <div className=" section-title">
                        <h2>ABOUT US</h2>
                    </div>
                <div className="what-Make-Us-whapper d-flex flex-column justify-content-start align-items-start">
  
                    <p className="what-Make-US-whapper-col-1">We are a cross-border marketing consultancy firm that caters to Asian brands across the world. Our purpose is to bridge the gap 
between Asian and Western markets. </p>
                    <p className="what-Make-US-whapper-col-1">
                    We empathise with various cultures, global consumer trends and industrial transformations to embrace your vision and invest all our 
                 expertise and passion to devise solutions that ensure success.
                    </p>
                    <p className="what-Make-US-whapper-col-2"> <b>We are On-Time. On-Budget. On-Point.</b></p>

                </div>
                </div>
            </div>
        </>
    )
};

export default WhatMakeUs;
